import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { MultimediaResponse } from '@web/shared/module/multimedia';
import { BrandSocialMediaResponse } from '../../../shared/api/responses/brand-social-media.response';
import { AdminBrandStatus } from '../../enums/admin-brand-status';
import { AdminBrandContextOperationsResponse } from './admin-brand-context-operations.response';

@jsonObject
export class AdminBrandDetailsResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(String)
  public readonly slug!: string;

  @jsonMember(String)
  public readonly description!: string;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(String)
  public readonly homeUrl?: Nillable<string>;

  @jsonMember(MultimediaResponse)
  public readonly logo?: Nillable<MultimediaResponse>;

  @jsonMember(MultimediaResponse)
  public readonly illustration?: Nillable<MultimediaResponse>;

  @jsonArrayMember(BrandSocialMediaResponse, { name: 'socialNetworks' })
  public readonly socialMedia!: BrandSocialMediaResponse[];

  @jsonMember(String)
  public readonly status!: AdminBrandStatus;

  @jsonMember(AdminBrandContextOperationsResponse)
  public readonly contextOperations!: AdminBrandContextOperationsResponse;
}
